<template>
  <div class="lanModify">
    <b-card class="clearBoth">
      <div class="header-top" ref="headerH">
        <div class="header-page-title">
          <svg @click="goBack()" class="icon icon-16 header-page-back" aria-hidden="true">
            <use xlink:href="#icon-v4_back"></use>
          </svg>
        </div>
      </div>
      <div class="note">
        <div class="left">
          <p style="margin-bottom: 20px">{{ $t("publicManage.lanset.fileName") }}：{{ lan + ".json" }}</p>
          <p style="white-space: pre-line">{{ $t("publicManage.lanset.text3") }}</p>
        </div>
        <div class="right">
          <!-- 下载语言包 -->
          <b-button variant="primary" class="g-btn" @click="downloadLine" style="margin-right: 20px;">{{
            $t("publicManage.lanset.text4")
          }}</b-button>
          <input type="file" ref="fileInput" class="input-hide" @change="chooseFile" />
          <b-button variant="primary" class="g-btn" @click="inputGetFile">{{ $t("publicManage.lanset.upload") }} {{ lan
            + ".json" }}</b-button>
        </div>
      </div>
    </b-card>
    <b-card class="table-card">
      <b-row>
        <b-col lg="3">
          <b-form-input v-model="key" placeholder="key"></b-form-input>
        </b-col>
        <b-col lg="3">
          <b-button variant="primary" style="margin-left: 6px" @click="query">
            {{ $t("common.search") }}</b-button>
          <b-button variant="primary" style="margin-left: 10px" @click="reset">
            {{ $t("common.reset") }}</b-button>
        </b-col>
        <b-col lg="6" class="header-right-btn">
          <el-checkbox v-model="onlyChange" class="only-change" @change="getList(1)">{{ $t("publicManage.lanset.text5")
            }}</el-checkbox>
          <b-button variant="light" style="margin-left: 10px;color:#095BE8" @click="ignoreAll">{{
            $t("publicManage.lanset.text6") }}</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12">
          <b-table class="table-striped table-md table-hover table-bordered table-responsive-md"
            :style="`margin-top: 24px;height:${$store.state.baseData.tableH}`" :items="list" :fields="fields"
            :show-empty="noData" :busy="loading" :sticky-header="$store.state.baseData.tableH">
            <!-- 暂无数据 -->
            <template v-slot:empty="scope">
              <h4 class="common-table-noData">
                <img src="../../assets/images/v4_nodata.png" alt="" />
                <div class="noData-text">
                  {{ $t("common.noData") }}
                </div>
              </h4>
            </template>
            <!-- loading -->
            <template v-slot:table-busy>
              <load-skeleton v-show="loading" :columns="6" :rows="5" :haveLeftNumber="false"></load-skeleton>
            </template>
            <!-- key -->
            <template v-slot:cell(changeKey)="row">
              <div class="text_line">
                {{ row.item.changeKey }}
              </div>
            </template>
            <!-- 原文 -->
            <template v-slot:cell(newValue)="row">
              <div class="text_line">
                {{ row.item.newValue }}
              </div>
            </template>
            <!-- 线上 -->
            <template v-slot:cell(oldValue)="row">
              <div class="text_line">
                {{ row.item.oldValue }}
              </div>
            </template>
            <!-- 状态 -->
            <template v-slot:cell(status)="row">
              <span>
                {{
            row.item.status === 1
              ? $t("publicManage.lanset.text10") // 有变动
              : '--'
          }}
              </span>
            </template>
            <template v-slot:cell(operation)="row">
              <b-button size="sm" variant="outline-primary" @click="edit(row.item, row)">
                <!-- 编辑 -->
                {{ $t("common_language.editor") }}
                <!-- {{$t('exTrade.eidt')}} -->
              </b-button>
              <b-button size="sm" variant="outline-primary" @click="ignore(row.item)" v-if="row.item.status === 1">
                <!-- 忽略变动 -->
                {{
            $t("publicManage.lanset.text11")
          }}
              </b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <v-page v-if="pages.total > 0" :total-rows="pages.total" :perPage="pages.size" :pageOptions="pages.options"
            :currentPage="pages.page" @initialize="pageChange"></v-page>
        </b-col>
      </b-row>
      <b-modal v-model="isEdit" :title="$t('common_language.editor')" id="small-modal" size="md" no-close-on-backdrop>
        <section>
          <b-form-textarea id="textarea" v-model="editContent" :class="{ 'is-invalid': !editContent && isSave }"
            rows="3" max-rows="12"></b-form-textarea>
          <p class="text-danger" v-if="!editContent && isSave">
            {{ $t("common.inputCheck", { checkName: '' }) }}
          </p>
        </section>
        <section class="deilog-bottom" slot="modal-footer">
          <!-- 取消 -->
          <b-button class="coustom-btn" @click="cancelEdit">
            {{ $t("publicManage.lanset.cancel") }}
          </b-button>
          <!-- 保存-->
          <b-button class="coustom-btn" variant="primary" @click="saveEdit" :disabled="isSave">
            {{ $t('common.save')}}
          </b-button>
        </section>
      </b-modal>
    </b-card>
  </div>
</template>

<script>
import commonMixin from "@/mixin/common/commonMixin";
import axios from "axios";
export default {
  name: "languageModify",
  mixins: [commonMixin],
  data() {
    return {
      key: "",
      onlyChange: true,
      list: [],
      noData: true,
      loading: false,
      pages: {
        page: 1, // 当前页数
        size: 10, // 页数大小
        options: [10, 40, 60, 100], // 页数大小选择
        total: 0 // 总页数
      },
      isEdit: false,
      editContent: '',
      isSave: false,
    };
  },
  watch: {},
  computed: {
    fields() {
      return [
        {
          key: "changeKey",
          label: "KEY",
        },
        {
          key: "newValue",
          label: this.$t("publicManage.lanset.text7"),
        },
        {
          key: "oldValue",
          label: this.$t("publicManage.lanset.text8"),
        },
        {
          key: "status",
          label: this.$t("publicManage.lanset.status"),
          class: "text-right",
        },
        {
          key: "operation",
          label: this.$t("common.find"),
          class: "text-right",
        }, //  操作
      ];
    },
    lan() {
      return this.$route.query.lan;
    },
    type() {
      return this.$route.query.type;
    },
    // 线上语言地址
    address() {
      return this.$route.query.address;
    },
    useType() {
      const list = {
        web: 1,
        app: 2,
        server: 5,
        admin: 6
      };
      const type = this.type.toLowerCase();
      return list[type];
    }
  },
  beforeMount() {
    this.updateLanguage()
  },
  methods: {
    // 英文数字字体
    addEnClass({ row, column }) {
      switch (column.property) {
        case "value":
          return "enNum";
      }
    },
    // 排序变化
    sortChanged(ctx) {
      switch (ctx.prop) {
        case "tradeAmount":
          this.sortName = "tradeAmount";
          break;
      }
      this.sortSet = ctx.order === "descending" ? 1 : 0;
    },
    // 更新语言包
    updateLanguage() {
      this.$http({
        url: this.$store.state.url.languageManage.updateLanguage,
        params: {
          langKey: this.lan,
          type: this.useType,
        }
      })
        .finally(() => {
          this.getList(1);
        });
    },
    // 查询
    query() {
      if (!this.findFlag) return
      this.findFlag = false;
      this.pages.page = 1
      this.getList()
    },
    // 重置
    reset() {
      this.key = '';
    },
    // 分页改变
    pageChange(data) {
      const { page, pageSize } = data
      this.pages.page = page
      this.pages.size = pageSize;
      this.getList();
    },
    // 获取列表
    getList(index) {
      if (index) {
        this.pages.page = index;
      }
      const params = {
        pageNum: this.pages.page,
        pageSize: this.pages.size,
        changeKey: this.key,
        onlyChange: this.onlyChange ? 1 : 0,
        type: this.useType,
        langKey: this.lan,
      };
      this.noData = false;
      this.loading = true;
      this.$http({
        url: this.$store.state.url.languageManage.getDiffLanguageInfo,
        params,
      }).then(({ data, code, msg }) => {
        this.findFlag = true
        this.loading = false
        if (data && code.toString() === '0') {
          this.list = data.resultList;
          this.noData = data.count === 0;
          this.pages.total = data.count;
        } else {
          this.$bus.$emit('alert', { type: 'error', message: msg })
        }
      })
        .catch((error) => {
          this.loading = false;
          this.noData = true;
          this.$bus.$emit('alert', { type: 'error', message: error })
        })
    },
    // 返回
    goBack() {
      this.$router.push({
        path: "languageService",
        query: {
          lanType: this.type,
        },
      });
    },
    // 格式化json
    formatJson(json, options) {
      let reg = null;
      let formatted = "";
      let pad = 0;
      const PADDING = " ";
      // eslint-disable-next-line no-param-reassign
      options = options || {};
      // eslint-disable-next-line no-param-reassign
      options.OrBracket = options.OrBracket === true;
      // eslint-disable-next-line no-param-reassign
      options.spaceAfterColon = options.spaceAfterColon !== false;
      if (typeof json !== "string") {
        // eslint-disable-next-line no-param-reassign
        json = JSON.stringify(json);
      } else {
        // eslint-disable-next-line no-param-reassign
        json = JSON.parse(json);
        // eslint-disable-next-line no-param-reassign
        json = JSON.stringify(json);
      }
      // eslint-disable-next-line no-useless-escape
      // reg = /([\{\}])/g;
      // eslint-disable-next-line no-param-reassign
      // json = json.replace(reg, '\r\n$1\r\n');
      // reg = /([\[\]])/g;
      // json = json.replace(reg, '\r\n$1\r\n');
      // eslint-disable-next-line no-useless-escape
      reg = /(\"\,)/g;
      // eslint-disable-next-line no-useless-escape
      // eslint-disable-next-line no-param-reassign
      json = json.replace(reg, '",\r\n');
      // eslint-disable-next-line no-useless-escape
      reg = /(\:\"\,\r\n)/g;
      // eslint-disable-next-line no-param-reassign
      json = json.replace(reg, ':",');
      // eslint-disable-next-line no-useless-escape
      reg = /\]\r\n\,/g;
      // eslint-disable-next-line no-param-reassign
      json = json.replace(reg, "],\r\n");
      // eslint-disable-next-line no-useless-escape
      reg = /\}\r\n\,/g;
      // eslint-disable-next-line no-param-reassign
      json = json.replace(reg, "},\r\n");
      reg = /(\r\n\{)/g;
      // eslint-disable-next-line no-param-reassign
      json = json.replace(reg, "{");
      reg = /(\r\n\r\n)/g;
      // eslint-disable-next-line no-param-reassign
      json = json.replace(reg, "\r\n");
      if (!options.OrBracket) {
        // eslint-disable-next-line no-useless-escape
        reg = /\:\r\n\{/g;
        // eslint-disable-next-line no-param-reassign
        json = json.replace(reg, ":{");
        // eslint-disable-next-line no-useless-escape
        reg = /\:\r\n\[/g;
        // eslint-disable-next-line no-param-reassign
        json = json.replace(reg, ":[");
      }
      if (options.spaceAfterColon) {
        // eslint-disable-next-line no-useless-escape
        reg = /\:/g;
        // eslint-disable-next-line no-param-reassign
        json = json.replace(reg, ":");
      }
      json.split("\r\n").forEach((node) => {
        let i = 0;
        let indent = 0;
        let padding = "";
        if (node.match(/\{$/) || node.match(/\[$/)) {
          indent = 1;
        } else if (node.match(/\}/) || node.match(/\]/)) {
          if (pad !== 0) {
            pad -= 1;
          }
        } else {
          indent = 0;
        }
        // eslint-disable-next-line no-plusplus
        for (i = 0; i < pad; i++) {
          padding += PADDING;
        }
        // json格式化不换行
        formatted += `${padding + node}`;
        // formatted += `${padding + node}\r\n`;
        pad += indent;
      });
      return formatted;
    },
    // 下载参照语言包
    downloadLine() {
      axios({
        method: "get",
        url: this.address,
        headers: {
          "content-type": "application/json",
        },
      }).then((data) => {
        const { lan } = this;
        const content = this.formatJson(data.data);
        const blob = new Blob([content]);
        const fileName = `${lan}.json`;
        // 非IE下载
        if ("download" in document.createElement("a")) {
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
          this.$bus.$emit("alert", {
            type: "success",
            message: this.$t("publicManage.lanset.saveSuccess"),
          });
        }
        else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
          this.$bus.$emit("alert", {
            type: "success",
            message: this.$t("publicManage.lanset.saveSuccess"),
          });
        }
      });
    },
    // 上传语言包
    inputGetFile() {
      this.$refs.fileInput.click();
    },
    /* 选择文件 */
    chooseFile(e) {
      const { lan } = this;
      const filePath = this.$refs.fileInput.files[0].name; // 上传图片的名称
      this.fileName = filePath;
      if (this.fileName !== `${lan}.json`) {
        this.$bus.$emit("alert", {
          type: "error",
          message: `${this.$t(
            "publicManage.lanset.fileNameshould"
          )}${lan}.json`,
        });
        return;
      }
      const reader = new FileReader();
      reader.readAsText(this.$refs.fileInput.files[0], "utf8"); // input.files[0]为第一个文件
      reader.onload = () => {
        try {
          const obj = JSON.parse(reader.result);
          if (typeof obj === "object" && obj) {
            let fileSize = 0;
            const fileMaxSize = 10 * 1024; // 上传文件的大小
            if (filePath) {
              fileSize = this.$refs.fileInput.files[0].size / 1024; // 实际上传文件的大小(转为单位为KB)
              if (fileSize > fileMaxSize) {
                this.$bus.$emit("alert", {
                  type: "warn",
                  message: this.$t("fileUpload.tip1"),
                });
                return;
              }
            }
            this.uploadFile();
            e.target.value = "";
          } else {
            this.$bus.$emit("alert", {
              type: "error",
              message: this.$t("publicManage.lanset.uploadjsonRigth"),
            });
            e.target.value = "";
            return;
          }
        } catch {
          e.target.value = "";
          this.$bus.$emit("alert", {
            type: "error",
            message: this.$t("publicManage.lanset.uploadjsonRigth"),
          });
        }
      };
    },
    // 上传语言包
    uploadFile() {
      console.log(this.type,'this.type')
      let type;
      if (this.type === "server") type = 5;
      if (this.type === "admin") type = 6;
      let formDatas = new FormData();
      formDatas.append("file", this.$refs.fileInput.files[0]);
      formDatas.append("type", type);
      formDatas.append("langType", this.lan);
      this.tip = true;
      this.$http({
        url: "language/uploadLangFile",
        headers: { "Content-Type": "multipart/form-data" },
        params: formDatas,
      }).then((data) => {
        if (data && data.code.toString() === "0") {
          this.$bus.$emit("alert", { type: "success", message: data.msg });
          this.tip = false;
          this.fileUrl = data.data.fileName;
          if (this.fileUrl) {
            this.upload(this.lan, this.type, this.fileUrl);
            this.$bus.$emit("alert", { type: "success", message: data.msg });
          }
        } else {
          this.$bus.$emit("alert", { type: "error", message: data.msg });
        }
      });
    },
    // 上传
    upload(lang, type, address) {
      let status = 1;
      if (this.type === "web") status = 1;
      if (this.type === "app") status = 2;
      if (this.type === "serve") status = 3;
      this.$http({
        url: "company_lang_cloud_address_update",
        params: {
          lang,
          type: status,
          address,
        },
      }).then((data) => {
        if (data.code.toString() === "0") {
          console.log(data);
          // this.getLang()
          // this.getDownloadAddress()
          this.$router.push("/languageService");
        } else {
          this.$bus.$emit("alert", { type: "error", message: data.msg });
        }
      });
    },
    // 忽略所有
    ignoreAll() {
      const text = this.$t('publicManage.lanset.text13')
      this.$bvModal.msgBoxConfirm(text, {
        title: this.$t('common.tip'),
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'primary',
        okTitle: this.$t('common.continue'),
        cancelTitle: this.$t('common.cancel'),
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(value => {
        if (value) {
          this.ignore(undefined, 1);
        }
      })
    },
    ignore(data, isAll) {
      const currentListNum = this.list.length;
      const isShowChange = this.onlyChange;
      this.$http({
        url: this.$store.state.url.languageManage.ignoringChanges,
        params: {
          type: this.useType,
          langKey: this.lan,
          keyPath: data && data.changeKey ? data.changeKey : undefined,
        },
      }).then(({ data, code, msg }) => {
        if (code.toString() === '0') {
          const requestFirst = isAll ? true : (isShowChange ? currentListNum - 1 === 0 : false);
          this.getList(requestFirst ? 1 : undefined);
        }
        this.$bus.$emit('alert', { type: code.toString() === '0' ? 'success' : 'error', message: msg })
      })
    },
    // 编辑
    edit(data, row) {
      this.editItem = {
        ...data,
        tableIndex: row.index,
      };
      this.isEdit = true;
      this.editContent = data.oldValue;
    },
    saveEdit() {
      const currentListNum = this.list.length;
      const isShowChange = this.onlyChange;
      this.isSave = true;
      if (!this.editContent) {
        return;
      }
      this.$http({
        url: this.$store.state.url.languageManage.updateChangeKeyContent,
        params: {
          type: this.useType,
          langKey: this.lan,
          keyPath: this.editItem.changeKey,
          content: this.editContent,
        },
      })
        .then(({ data, code, msg }) => {
          if (code.toString() === '0') {
            const requestFirst = isShowChange ? currentListNum - 1 === 0 : false;
            this.getList(requestFirst ? 1 : undefined)
            this.cancelEdit();
          }
          this.$bus.$emit('alert', { type: code.toString() === '0' ? 'success' : 'error', message: msg })
        })
        .finally(() => {
          setTimeout(() => {
            this.isSave = false;
          }, 500);
        })
    },
    cancelEdit() {
      this.editItem = {};
      this.isEdit = false;
      this.editContent = "";
      this.isSave = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.lanModify {
  .text_line {
    line-height: 20px;
    white-space: normal;
    padding: 17px 0;
    word-break: break-word;
  }

  .leftText {
    width: 49.8%;
    float: left;
  }

  .rightText {
    width: 49.8%;
    float: right;
  }

  .textTitle {
    height: 30px;
    background: #fff;
    line-height: 30px;
    padding-left: 10px;
    font-weight: 700;
  }

  .textArea {
    height: 760px;

    textarea {
      width: 100%;
      height: 100%;
      resize: none;
    }
  }

  .clearBoth {
    clear: both;
    border-radius: 16px 16px 0px 0px !important;

    .card-body {
      padding: 10px;
    }
  }

  .table-card {
    border-radius: 0px 0px 16px 16px !important;
  }

  .input-hide {
    display: none;
  }

  .note {
    background: #F7F8F9;
    padding: 24px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: 0 10px;
    gap: 20px;

    .left {
      color: #263954;
      font-family: HarmonyOS-Medium;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      min-height: 83px;

      p {
        margin-bottom: 0;
      }

      p:first-child {
        font-size: 18px;
      }

      p:last-child {
        font-size: 14px;
      }
    }

    .right {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;

      .g-btn {
        white-space: nowrap;
      }
    }
  }

  .card-header {
    padding-bottom: 0px;
  }

  .only-change {
    font-size: 12px;
    margin-bottom: 0;

    &.is-checked {
      background: unset !important;
    }

    ::v-deep .el-checkbox__label {
      font-size: 12px;
      color: #37435B !important;
    }

    ::v-deep .el-checkbox__inner {
      border-radius: 50%;
      width: 14px !important;
      height: 14px !important;
    }

    ::v-deep .el-checkbox__inner::after {
      transition: unset !important;
    }

    ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner::after {
      transform: unset !important;
      width: 8px !important;
      height: 8px !important;
      border-radius: 50%;
      background: #095BE8;
      left: 2px !important;
      top: 2px !important;
      border: unset !important;

    }
  }
}
</style>
